import { useContext } from 'react'
import { Helmet } from 'react-helmet-async'

import { faCheckCircle } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Columns, DashboardModule, LoadingModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import { generateUrls } from '@hooks/usePortal'
import usePortals from '@hooks/usePortals'

import ListBlankState from '@components/ListBlankState'
import PageFilterModule from '@components/PageFilterModule'
import PageHeader from '@components/PageHeader'

import PortalListItem from '../PortalListItem'

const buildPageFilterFields = () => {
  const style = { marginBottom: 16 }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Title or ID',
    },
  ]
}

interface PageContentProps {
  pageFilters: {
    [key: string]: any,
  },
}

const PageContent = (props: PageContentProps) => {
  const { pageFilters } = props

  const portalsPayload = usePortals({
    filters: pageFilters,
    performHttpRequests: true,
    requestOptions: { include_pagination_rule_brand: true },
  })

  const {
    callbacks: { loadMore },
    canLoadMore,
    filteredPortals,
    filteredPortalsCount,
    hasFilteredPortals,
    loading,
  } = portalsPayload

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      resetFilters,
      showCreatePortalModal,
      updateFilters,
    },
    defaultFilters,
  } = pageContext

  const { portalsIndexUrl } = generateUrls()

  return (
    <>
      <Helmet>
        <title>Portals | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button buttonStyle="primaryCreate" onClick={() => showCreatePortalModal()} size="medium">
            Create
          </Button>
        )}
        activeTabBarItemKey="portals"
        tabBarItems={[
          {
            href: portalsIndexUrl,
            icon: faCheckCircle,
            key: 'portals',
            title: 'Portals',
          },
        ]}
        title="Portals"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <LoadingModule loading={loading} times={3} />

            {!loading && !hasFilteredPortals && <ListBlankState />}

            {!loading && hasFilteredPortals && (
              <DashboardModule title="Systems">
                <Box flexDirection="column">
                  <Box flexDirection="column">
                    {filteredPortals.map(portal => (
                      <PortalListItem key={portal.id} portal={portal} />
                    ))}
                  </Box>

                  <DashboardModule.LoadMoreFooter
                    // @ts-expect-error TS2322
                    callbacks={{ loadMore }}
                    canLoadMore={canLoadMore}
                    entityCount={filteredPortalsCount}
                    loading={loading}
                  />
                </Box>
              </DashboardModule>
            )}
          </Columns.Main>

          <Columns.Sidebar>
            <PageFilterModule
              callbacks={{ resetFilters, updateFilters }}
              defaultFilters={defaultFilters}
              // @ts-expect-error TS2322
              filterFields={buildPageFilterFields()}
              pageFilters={pageFilters}
              title="Filters"
            />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
